import { defineMessages } from "react-intl"

export default defineMessages({
  gamingGenres: {
    id: "app.components.GamingGenres.gamingGenres",
  },
  "gamingGenres.ActionAdventure": {
    id: "app.components.GamingGenres.gamingGenres.ActionAdventure",
  },
  "gamingGenres.Adventure": {
    id: "app.components.GamingGenres.gamingGenres.Adventure",
  },
  "gamingGenres.CardGame": {
    id: "app.components.GamingGenres.gamingGenres.CardGame",
  },
  "gamingGenres.Fighting": {
    id: "app.components.GamingGenres.gamingGenres.Fighting",
  },
  "gamingGenres.Fitness/Dance": {
    id: "app.components.GamingGenres.gamingGenres.Fitness/Dance",
  },
  "gamingGenres.HackAndSlash": {
    id: "app.components.GamingGenres.gamingGenres.HackAndSlash",
  },
  "gamingGenres.Indie": {
    id: "app.components.GamingGenres.gamingGenres.Indie",
  },
  "gamingGenres.MMO": {
    id: "app.components.GamingGenres.gamingGenres.MMO",
  },
  "gamingGenres.MOBA": {
    id: "app.components.GamingGenres.gamingGenres.MOBA",
  },
  "gamingGenres.Music/Rhythm": {
    id: "app.components.GamingGenres.gamingGenres.Music/Rhythm",
  },
  "gamingGenres.Platformer": {
    id: "app.components.GamingGenres.gamingGenres.Platformer",
  },
  "gamingGenres.Puzzle": {
    id: "app.components.GamingGenres.gamingGenres.Puzzle",
  },
  "gamingGenres.Racing": {
    id: "app.components.GamingGenres.gamingGenres.Racing",
  },
  "gamingGenres.RPG": {
    id: "app.components.GamingGenres.gamingGenres.RPG",
  },
  "gamingGenres.Shooter": {
    id: "app.components.GamingGenres.gamingGenres.Shooter",
  },
  "gamingGenres.ShootEmup": {
    id: "app.components.GamingGenres.gamingGenres.ShootEmup",
  },
  "gamingGenres.Sports": {
    id: "app.components.GamingGenres.gamingGenres.Sports",
  },
  "gamingGenres.Simulation": {
    id: "app.components.GamingGenres.gamingGenres.Simulation",
  },
  "gamingGenres.Stealth": {
    id: "app.components.GamingGenres.gamingGenres.Stealth",
  },
  "gamingGenres.Strategy": {
    id: "app.components.GamingGenres.gamingGenres.Strategy",
  },
  "gamingGenres.Survival/Horror": {
    id: "app.components.GamingGenres.gamingGenres.Survival/Horror",
  },
  "gamingGenres.BattleRoyale": {
    id: "app.components.GamingGenres.gamingGenres.BattleRoyale",
  },
  "gamingGenres.Metroidvania": {
    id: "app.components.GamingGenres.gamingGenres.Metroidvania",
  },
})
